/**
 * @generated SignedSource<<0ab4a9e07dee08861e1b7e1b0f817e0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EndStudentTargetFocusesInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  userIds: ReadonlyArray<string>;
};
export type StudentTargetFocusEndMutation$variables = {
  input: EndStudentTargetFocusesInput;
};
export type StudentTargetFocusEndMutation$data = {
  readonly endStudentTargetFocuses: {
    readonly studentTargetFocusNode: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
    }> | null | undefined;
  };
};
export type StudentTargetFocusEndMutation = {
  response: StudentTargetFocusEndMutation$data;
  variables: StudentTargetFocusEndMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EndStudentTargetFocusesPayload",
    "kind": "LinkedField",
    "name": "endStudentTargetFocuses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentTargetFocusNode",
        "kind": "LinkedField",
        "name": "studentTargetFocusNode",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusEndMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusEndMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1779ff145ad8d5e9e1faae652a6677d2",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusEndMutation",
    "operationKind": "mutation",
    "text": "mutation StudentTargetFocusEndMutation(\n  $input: EndStudentTargetFocusesInput!\n) {\n  endStudentTargetFocuses(input: $input) {\n    studentTargetFocusNode {\n      id\n      isActive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4443ddfcb9ac9dfe3597f998e8ab0a2";

export default node;
